import CheckboxGroup from "../../../../search-filter-options/CheckboxGroup/CheckboxGroup";
import { PropertyFeature } from "../../../../../types/constants";
import styles from "./PropertyFeaturesOption.module.scss";

import { ReactComponent as TetonViewIcon } from "../../../../../assets/icons/property-feature/teton-view.svg";
import { ReactComponent as NoCCRSIcon } from "../../../../../assets/icons/property-feature/no-subdivision.svg";
import { ReactComponent as TreesOnLotIcon } from "../../../../../assets/icons/property-feature/trees-on-lot.svg";
import { ReactComponent as WaterOnLotIcon } from "../../../../../assets/icons/property-feature/water-on-lot.svg";

interface PropertyFeatureOptionProps {
  value: PropertyFeature[];
  onChange: (values: string[]) => void;
  className?: string;
}

export default function PropertyFeatureOption({
  value,
  onChange,
  className,
}: PropertyFeatureOptionProps) {
  return (
    <CheckboxGroup
      label="Property Features"
      name="property-features"
      value={value}
      className={className}
      options={[
        {
          label: "Teton View",
          value: PropertyFeature.TetonView,
          icon: <TetonViewIcon className={styles.icon} />,
          buttonName: "Teton view",
        },
        {
          label: "No Subdivision",
          value: PropertyFeature.NoSubdivisions,
          icon: <NoCCRSIcon className={styles.icon} />,
          buttonName: "No subdivisions",
        },
        {
          label: "Trees on Lot",
          value: PropertyFeature.TreesOnLot,
          icon: <TreesOnLotIcon className={styles.icon} />,
          buttonName: "Trees on lot",
        },
        {
          label: "Water on Lot",
          value: PropertyFeature.WaterOnLot,
          icon: <WaterOnLotIcon className={styles.icon} />,
          buttonName: "Water on lot",
        },
      ]}
      onChange={onChange}
    />
  );
}
